// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"80628a36","511":"ceffbb0b"}[chunkId] + ".chunk.js";
};